import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useAddExamGroupQuestion = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const addExamGroupQuestion = async (examGroupQuestion: any) => {
        try {
            const response = await axios.post("/api/examgroup/addquestions", examGroupQuestion);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.addExamGroupQuestion"));
        }
    }

    return useMutation({mutationFn: addExamGroupQuestion, onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ["examGroupQuestions"]});
        queryClient.invalidateQueries({queryKey: ["examGroups"]})
        queryClient.invalidateQueries({queryKey: ["examQuestionSummary"]})
        message.success(t("messages.success.addExamGroupQuestion"));
    }});
}